<!--

	Show a replacement when a condition is not met.

	Syntactic sugar used, e.g., when lists are empty and we want to display a message instead of an empty list.

-->
<template>
	<transition name="mia-ConditionalReplacement-transition" mode="out-in">
		<div :key="(condition || !applyTransition).toString()">
			<slot v-if="condition" />
			<slot v-else name="replacement">
				<div class="alert alert-info" role="alert">
					{{ messageOtherwise }}
				</div>
			</slot>
		</div>
	</transition>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";

@Component
export class ConditionalReplacement extends Vue {
	@Prop({ type: Boolean, required: true }) condition!: boolean;
	@Prop({ type: String, required: true }) messageOtherwise!: string;
	@Prop({ type: Boolean, required: false, default: true }) applyTransition!: boolean;
}

export default toNative(ConditionalReplacement);
</script>
<style lang="scss">
.mia-ConditionalReplacement-transition-enter-active {
	animation: mia-animation-fade .3s reverse;
}

.mia-ConditionalReplacement-transition-leave-active {
	animation: mia-animation-fade .3s both;
}

@keyframes mia-animation-fade {
	40% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
</style>
